import React from "react";
import "./layout.css";
import { Routes, Route } from "react-router-dom";
import Home from "../Admin/Home/Home";
import Login from "../Admin/Login/Login";

import ProtectedRoutes from "../Admin/ProtectedRoutes/ProtectedRoutes";
import PageNotFound from "../Admin/PageNotFound/PageNotFound";
import Xtreams from "../Admin/Xtream/List";
import Devices from "../Admin/Device/List";
import Disconnected from "../Admin/Xtream/Disconnected";
import ChangePassword from "../Admin/Login/ChangePassword";

import Settings from "../Admin/Setting/List";
import EditSetting from "../Admin/Setting/Edit";

import Playlists from "../Admin/Playlist/List";

const Routing = () => {
  return (
    <>
      {/* auth routes */}
      <Routes>
        <Route exact={true} path="/login" element={<Login />} />
        <Route exact={true} path="*" element={<PageNotFound />} />

        {/* protected routes */}

        <Route
          exact={true}
          path="/"
          element={<ProtectedRoutes Component={Home} />}
        />

        <Route
          exact
          path="/xtreams"
          element={<ProtectedRoutes Component={Xtreams} />}
        />

        <Route
          exact
          path="/devices"
          element={<ProtectedRoutes Component={Devices} />}
        />

        <Route
          exact
          path="/changepassword"
          element={<ProtectedRoutes Component={ChangePassword} />}
        />

        <Route
          exact
          path="/settings"
          element={<ProtectedRoutes Component={Settings} />}
        />

        <Route
          exact
          path="/settings/:id/edit"
          element={<ProtectedRoutes Component={EditSetting} />}
        />

        <Route
          exact
          path="/disconnectedxtreams"
          element={<ProtectedRoutes Component={Disconnected} />}
        />

        <Route
          exact
          path="/playlists"
          element={<ProtectedRoutes Component={Playlists} />}
        />
      </Routes>
    </>
  );
};
export default Routing;
